import { Form } from "react-bootstrap";

const Input = (props) => {
    return (
        <Form.Group>
            <Form.Label>{props.required && '*'} {props.label}</Form.Label>
            <Form.Control type={props.type || 'text'} {...props.register}
                aria-label={props.label}
            />
            {props.message && <Form.Control.Feedback type="invalid" style={props.errors ? {display:'block'} : { display: 'none'}}>{props.message}</Form.Control.Feedback>}
            {!props.message && <Form.Control.Feedback type="invalid" style={props.errors ? {display:'block'} : { display: 'none'}}>This field is required</Form.Control.Feedback>}
        </Form.Group>
    )
}

export default Input;